/**
 * Per-page TTL constants for the L1+L2 cache.
 *
 * All values in milliseconds. Naming convention: <DOMAIN>_TTL_MS
 *
 * Rules:
 *  - All values must be ≤ CacheConfig.ttl (global ceiling: 60 min).
 *  - Add a new constant here whenever a page/feature needs its own TTL.
 *  - Never hardcode milliseconds in hook files — always import from here.
 */

/** Dashboard page: chart data + metrics + registry — 25 minutes */
export const DASHBOARD_TTL_MS = 25 * 60 * 1_000;   // 1_500_000

/** Admin page: admin_overview SQL — 10 minutes */
export const ADMIN_TTL_MS = 10 * 60 * 1_000;        // 600_000

/** Agro dashboard pickers: activities ranking + zones by usage — 60 minutes */
export const AGRO_DASHBOARD_TTL_MS = 60 * 60 * 1_000; // 3_600_000

/** Agro dashboard SQL data: KPIs, zonas, heatmap (DynamicTable/generate) — 10 minutes */
export const AGRO_DASHBOARD_DATA_TTL_MS = 10 * 60 * 1_000; // 600_000

/**
 * Trazabilidad dashboard: SQL data AND the last-view snapshot — 30 minutes.
 *
 * Both share this value on purpose: the snapshot restores the filters the user left
 * with, and the data cached under those filters has to live as long as the snapshot or
 * the page would reopen "instantly" onto a spinner.
 */
export const TRAZABILIDAD_TTL_MS = 30 * 60 * 1_000; // 1_800_000

/**
 * Día a día and Consolidados dynamic tables: SQL data AND the last-view snapshot — 30
 * minutes. Same reasoning as TRAZABILIDAD_TTL_MS: snapshot and data must expire together.
 */
export const TABLE_PAGE_TTL_MS = 30 * 60 * 1_000; // 1_800_000

/**
 * Vigilancia table view and Vigilancia informe: SQL data AND the last-view snapshot — 30
 * minutes. Same reasoning as TRAZABILIDAD_TTL_MS: snapshot and data must expire together.
 */
export const VIGILANCIA_TTL_MS = 30 * 60 * 1_000; // 1_800_000

/** Devices dashboard (GET /Dashboards/GetDevicesDashboard) — 10 minutes, same as its Redis TTL */
export const DEVICES_DASHBOARD_TTL_MS = 10 * 60 * 1_000; // 600_000

/**
 * Explicit reference for call sites that want to be self-documenting.
 * Omitting cacheTtlMs is equivalent to passing this value.
 */
export const DEFAULT_TABLE_TTL_MS = 30 * 60 * 1_000; // 1_800_000
